import { Link } from 'react-router-dom'
import { ShieldX } from 'lucide-react'
import type { Capability } from '@/api/schema'
import { Badge } from '@/components/ui/badge'
import { DEFAULT_ROUTE } from '../navigation'

/** 403 de UX: o usuário está autenticado mas o perfil não inclui a capability. */
export function ForbiddenPage({ permission = [] }: { permission?: Capability[] }) {
  return (
    <div
      role="alert"
      data-testid="forbidden-page"
      className="flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-border bg-card/60 px-6 py-12 text-center"
    >
      <span className="flex h-11 w-11 items-center justify-center rounded-full bg-red-50 dark:bg-red-950/40">
        <ShieldX className="h-5 w-5 text-red-600 dark:text-red-400" aria-hidden />
      </span>
      <div>
        <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
          Erro 403
        </p>
        <h1 className="mt-1 text-base font-semibold">Acesso negado</h1>
        <p className="mx-auto mt-1 max-w-md text-sm text-muted-foreground">
          Seu perfil não tem permissão para acessar esta área. Se precisar de acesso, peça a um
          administrador do Woctools.
        </p>
        {permission.length > 0 ? (
          <div className="mt-3 flex flex-wrap justify-center gap-1.5">
            <span className="text-xs text-muted-foreground">Permissão necessária:</span>
            {permission.map((item) => (
              <Badge key={item} tone="neutral" className="font-mono">
                {item}
              </Badge>
            ))}
          </div>
        ) : null}
      </div>
      <Link
        to={DEFAULT_ROUTE}
        className="text-sm font-medium text-primary-text underline-offset-4 hover:underline"
      >
        Voltar para o início
      </Link>
    </div>
  )
}
